import app from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyCCAv4NOUMUTxEONpHPmRbzvH21_JMpuzM",
    authDomain: "soundtrail-builder.firebaseapp.com",
    databaseURL: "https://soundtrail-builder.firebaseio.com",
    projectId: "soundtrail-builder",
    storageBucket: "soundtrail-builder.appspot.com",
    messagingSenderId: "1069872866631",
    appId: "1:1069872866631:web:07608e21c742220acf5862",
    measurementId: "G-8Y2LLT68KD"
};

class Firebase {
    constructor() {
        app.initializeApp(config);
        this.auth = app.auth();
        this.db = app.firestore();
        this.storage = app.storage();
    }

    doCreateUserWithEmailAndPassword = (name, email, password) => 
         this.auth.createUserWithEmailAndPassword(email, password).then(
            (result) => {

                //this.auth.currentUser
                let docRef = this.db.collection('users').doc(this.auth.currentUser.uid);
                let uid = this.auth.currentUser.uid;

                let setAda = docRef.set({
                    name: name,
                    company: '',
                    awsId: 'AKIAUBQJ36IAK4CB4B6W',
                    awsKey: 'pF3wJHeKT3sUnTgeoBFQ7xpMhvzxS8VrUP1BRnT9',
                    copyright: 'Copyright '+name+' 2022',
                    audioBaseUrl: 'https://soundtrail-sandpit-data.s3-ap-southeast-2.amazonaws.com/'+uid+'/audio/',
                    stxUrl: 'https://soundtrail-sandpit-data.s3-ap-southeast-2.amazonaws.com/'+uid+'/stx/',
                    imageBaseUrl: 'https://soundtrail-sandpit-data.s3-ap-southeast-2.amazonaws.com/'+uid+'/images/',
                    uuid: uid
                });
                setAda.then((v) => { console.log(v) })
            });
        
    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = password =>
        this.auth.currentUser.updatePassword(password);

    getSoundtrailList = () => {
        if (this.auth.currentUser != null) {
            return this.db.collection('soundtrails').where("editor", "==", this.auth.currentUser.uid).get();
        } else return new Promise((() => null))
    }
    getSoundtrailData = (docID) => {
        if (this.auth.currentUser != null) {
            return this.db.collection('soundtrails').doc(docID).get();
        } else return new Promise((() => null))
    }
    getUserData = () => {
        if (this.auth.currentUser != null) {
            return this.db.collection('users').doc(this.auth.currentUser.uid).get();
        } else return new Promise((() => null))
    }
    createSoundtrail = (name, tags, owner, soundtrailKmlFileUrl, tileImageUrl, editor, code) => {
        if (this.auth.currentUser != null) {
            let time = new Date(Date.now());
            return this.db.collection('soundtrails').doc().set({
                name:name,
                tags:tags,
                owner:owner,
                soundtrailKmlFileUrl:soundtrailKmlFileUrl,
                tileImageUrl:tileImageUrl,
                editor:editor,
                code:code,
                lastUpdated:time
            });
        } else return new Promise((() => null))
    }
    editSoundtrail = (id, newData) => {
        if (this.auth.currentUser != null) {
            let time = new Date(Date.now());
            newData.lastUpdated = time;
            return this.db.collection('soundtrails').doc(id).update(newData);
        } else return new Promise((() => null))
    }
    /// returns true if sandpit code is free
    checkSoundtrailCode = async (code) => {
        if (this.auth.currentUser != null) {
            let query = await this.db.collection('soundtrails').where("code", "==", code).get();
            return query.empty
        } else return false;
    }
    setThumbnail = (name, file) => {
        if (this.auth.currentUser != null) { 
            return this.storage.ref().child(name).put(file);
        } else return new Promise((() => null));
    }
    getThumbnail = (name) => {
        if (this.auth.currentUser != null) { 
            return this.storage.ref(name).getDownloadURL();
        } else return new Promise((() => null));
    } 
}

export default Firebase;